define.alias("shared/components/shared/wizard/slide-count", "settings/components/shared/wizard/slide-count");